export default "__VITE_ASSET__Mo7smLHY__"